import { cartFieldsQuery } from './getCart'
import { catalogFieldsQuery } from './getCatalog'
import { sessionFieldsQuery } from './getSession'
import { gql } from './gql'

/**
 * Cart, session and catalog in a single round trip. This is what the storefront
 * boots on: without it the first paint waits on three sequential requests.
 *
 * TODO(post-hackathon): cinnamon also ships `getInitialCategoriesValues`, the
 * same query with `categories` in place of `catalog`. Category navigation is
 * out of scope for this slice, so that variant is not ported.
 */
export const GET_INITIAL_CATALOG_VALUES = gql`
  query InitialCatalogValues(
    $storefrontName: String!
    $sessionUid: ID!
    $catalogSessionUid: String!
    $categoryName: String
    $pagination: PaginationInput
  ) {
    cart(storefrontName: $storefrontName, sessionUid: $sessionUid) {
      ${cartFieldsQuery}
    }
    session(storefrontName: $storefrontName, id: $sessionUid) {
      ${sessionFieldsQuery}
    }
    catalog(
      storefrontName: $storefrontName
      sessionUid: $catalogSessionUid
      category: $categoryName
      pagination: $pagination
    ) {
      ${catalogFieldsQuery}
    }
  }
`
